import { User } from '@wavingroup/iot-core/gen/ts/wavin/ignite/v1/user_pb';
import { GlobalPermissionType } from '@wavingroup/iot-core/gen/ts/wavin/kleos/v1/global_permission_pb';
import { UserModel } from '~/shared/models/user/UserModel';

export class UsersListModel {
  users: UserModel[];

  constructor(
    users: User[],
    globalPermissionsBySubject: Map<string, GlobalPermissionType[]> = new Map(),
  ) {
    this.users = users
      .map(
        (user) =>
          new UserModel(user, globalPermissionsBySubject.get(user.name) ?? []),
      )
      .sort((a, b) => a.email.localeCompare(b.email));
  }

  addUser(user: UserModel) {
    this.users = [user, ...this.users].sort((a, b) =>
      a.email.localeCompare(b.email),
    );
    return this;
  }
}
